"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react")); // tslint:disable-next-line


require("glider-js");

var GliderComponent =
/** @class */
function (_super) {
  __extends(GliderComponent, _super);

  function GliderComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.ref = React.createRef();
    return _this;
  }

  GliderComponent.prototype.componentDidUpdate = function () {
    var updatedProps = this.props; // @ts-ignore

    this.glider.setOption(__assign({}, updatedProps, {
      arrows: updatedProps.hasArrows ? {
        next: updatedProps.arrows && updatedProps.arrows.next ? updatedProps.arrows.next : '.glider-next',
        prev: updatedProps.arrows && updatedProps.arrows.prev ? updatedProps.arrows.prev : '.glider-prev'
      } : undefined,
      dots: updatedProps.hasDots ? updatedProps.dots ? updatedProps.dots : '#dots' : undefined
    }));
    this.glider.refresh(true);
  };

  GliderComponent.prototype.componentDidMount = function () {
    var _this = this;

    if (!this.ref.current) {
      return;
    } // @ts-ignore


    this.glider = new Glider(this.ref.current, __assign({}, this.props, {
      arrows: this.props.hasArrows ? {
        next: this.props.arrows && this.props.arrows.next ? this.props.arrows.next : '.glider-next',
        prev: this.props.arrows && this.props.arrows.prev ? this.props.arrows.prev : '.glider-prev'
      } : undefined,
      dots: this.props.hasDots ? this.props.dots ? this.props.dots : '#dots' : undefined
    }));

    var addEventListener = function addEventListener(event, fn) {
      if (typeof fn === 'function' && _this.ref.current) {
        _this.ref.current.addEventListener(event, fn);
      }
    };

    addEventListener('glider-slide-visible', this.props.onSlideVisible);
    addEventListener('glider-loaded', this.props.onLoad);
    addEventListener('glider-animated', this.props.onAnimated);
    addEventListener('glider-remove', this.props.onRemove);
    addEventListener('glider-refresh', this.props.onRefresh);
    addEventListener('glider-add', this.props.onAdd);
    addEventListener('glider-destroy', this.props.onDestroy);
    addEventListener('glider-slide-hidden', this.props.onSlideHidden);
  };

  GliderComponent.prototype.componentWillUnmount = function () {
    var _this = this;

    var removeEventListener = function removeEventListener(event, fn) {
      if (typeof fn === 'function' && _this.ref.current) {
        _this.ref.current.removeEventListener(event, fn);
      }
    };

    removeEventListener('glider-slide-visible', this.props.onSlideVisible);
    removeEventListener('glider-loaded', this.props.onLoad);
    removeEventListener('glider-animated', this.props.onAnimated);
    removeEventListener('glider-remove', this.props.onRemove);
    removeEventListener('glider-refresh', this.props.onRefresh);
    removeEventListener('glider-add', this.props.onAdd);
    removeEventListener('glider-destroy', this.props.onDestroy);
    removeEventListener('glider-slide-hidden', this.props.onSlideHidden);
  };

  GliderComponent.prototype.positionGlider = function () {
    if (this.props.scrollToSlide && this.glider) {
      this.glider.scrollItem(this.props.scrollToSlide - 1);
    } else if (this.props.scrollToPage && this.glider) {
      this.glider.scrollItem(this.props.scrollToPage - 1, true);
    }
  };

  GliderComponent.prototype.render = function () {
    this.positionGlider();
    return React.createElement("div", {
      className: "glider-contain"
    }, this.props.hasArrows && !this.props.arrows && React.createElement("button", {
      role: "button",
      className: "glider-prev",
      id: "glider-prev"
    }, this.props.iconLeft || '«'), React.createElement("div", {
      className: this.props.className,
      ref: this.ref
    }, this.props.children), this.props.hasDots && !this.props.dots && React.createElement("div", {
      id: "dots",
      className: "glider-dots"
    }), this.props.hasArrows && !this.props.arrows && React.createElement("button", {
      role: "button",
      className: "glider-next",
      id: "glider-next"
    }, this.props.iconRight || '»'));
  };

  return GliderComponent;
}(React.Component);

exports.default = GliderComponent;